import { palette } from '../palette';

export const MuiCssBaseline = {
  styleOverrides: {
    '@global': {
      '*::-webkit-scrollbar': {
        width: '5px',
        backgroundColor: '#F5F5F5',
      },
      '*::-webkit-scrollbar-track': {
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
        backgroundColor: palette.background.default,
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: palette.grey.dark,
        border: '2px solid',
        borderColor: palette.grey.dark,
      },
    },
  },
};
